import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { Base64 } from 'js-base64';
import { Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import Spinner from '@dbk/ui-spinner';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import download from '../../../../../../src/muster/utils/downloader';
import { getDocumentName } from '../../../../../../src/components/common/reports-name-conventions/reports-name-conventions';


function getURL(fileName, bytes) {
  const blob = new Blob([bytes], { type: "application/pdf" }, fileName);
  const url = URL.createObjectURL(blob);
  return url;
};

function modalContent(pdfStr, screen, closePdf, onCloseBlurModel,
  headerLabel, messages, pdfDataDownloadInProgress, extType) {
  // const pdfData = encode(pdfStr);

  const screenHeight = screen ? screen.height : $(window).height();

  const pdfData =  pdfStr !== '' && getURL("filename", pdfStr);

  if (!pdfDataDownloadInProgress && !pdfData) {
    closePdf();
    return (
      <div>
        <Large>{messages['app.reports.unablePdf']}</Large>
      </div>
    );
  }
  closePdf();
  if (pdfData) {
    // const url = 'data:application/pdf;base64,' + pdfData;
    const url = pdfData +'#view=fitH&toolbar=0' ;
    return (

      <div style={{ width: "100%" }}>
        <embed src={url} width="100%" type="application/pdf" style={{ 'minHeight': screenHeight - 250 }} />

      </div>
    )
  }
  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', alignSelf: 'center' }}>
      <Spinner />
    </View>
  );
}

function downloadDocument(headerLabel, pdfData, extType, documentType, documentName) {
  if(documentName){
    download(pdfData, getDocumentName(documentName) + extType, documentType);
  }else{
    download(pdfData, headerLabel + extType, documentType);
  }
}


const ReportPreview = ({
  modalVisible,
  doneLabel,
  onCloseBlurModel,
  headerLabel,
  closePdf,
  screen,
  pdfData,
  messages,
  pdfDataDownloadInProgress,
  extType,
  documentDownloadDisabled,
  documentType,
  documentName }) => (
    <div  >
      {
        modalVisible ?
          <div>
            <BlurModal
              visible={modalVisible}
              doneLabel={doneLabel}
              doneVisible
              onDone={onCloseBlurModel}
              headerChildren={headerLabel}
              title={headerLabel}
              // size="large"
              full
            >
              {modalContent(pdfData, screen, closePdf, onCloseBlurModel, headerLabel, messages, pdfDataDownloadInProgress, extType)}
              {pdfData && <div style={{ float: "right", marginTop: '10px' }}>
                <Button
                  size='large'
                  // make muster call for mark as read options
                  onClick={() => downloadDocument(headerLabel, pdfData, extType, documentType, documentName)}
                  disabled = {documentDownloadDisabled} /* To disable download for RM login on behalf */
                >
                  {messages['app.chedelivery.reports.download']}
                </Button>
              </div>}
            </BlurModal>
          </div>
          : null
      }
    </div>
  );

ReportPreview.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  modalVisible: PropTypes.bool,
  pdfId: PropTypes.string,
  doneLabel: PropTypes.string,
  onCloseBlurModel: PropTypes.function,
  headerLabel: PropTypes.string,
  closePdf: PropTypes.function,
  pdfData: PropTypes.string,
};

ReportPreview.defaultProps = {
  modalVisible: PropTypes.bool,
  pdfId: PropTypes.string,
  doneLabel: PropTypes.string,
  onCloseBlurModel: PropTypes.function,
  headerLabel: PropTypes.string,
  closePdf: PropTypes.function,
  pdfData: PropTypes.string,
  messages: PropTypes.array,
};

export default ReportPreview;
